import React from 'react';
import { Grid, Skeleton } from '@mui/material';

function LoadingCards() {
  return (
    <Grid container spacing={3}>
      {Array.from(new Array(8)).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Skeleton sx={{ aspectRatio: '3/4', borderRadius: '10px' }} height="auto" variant="rectangular" width="100%" />
        </Grid>
      ))}
    </Grid>
  );
}

export default LoadingCards;
